import { PODIUM_CLASSES } from '@/components/leaderboard/podiumClasses';
import { cn } from '@/lib/utils';

interface RankPillProps {
  /** 1-based rank; 1–3 receive podium tinting. */
  rank: number;
  /** Extra classes for sizing overrides. */
  className?: string;
}

/**
 * A circular, monospaced rank badge with podium tinting for the top three.
 *
 * @param props - The rank to display and optional sizing overrides.
 * @returns A tinted rank pill.
 */
export function RankPill({ rank, className }: RankPillProps) {
  return (
    <span
      className={cn(
        'flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-mono text-xs font-semibold tabular-nums',
        PODIUM_CLASSES[rank] ?? 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {rank}
    </span>
  );
}
